/**
 * Certifications MindSyncX Labs actually holds.
 *
 * Transcribed from the certificates in docs/ — nothing here is inferred. Both
 * were issued by Royal Assessments Pvt. Ltd. (RAPL), which is accredited by
 * EGAC, a member of the International Accreditation Forum and a signatory of
 * its MLA, so each is independently verifiable at iafcertsearch.org.
 *
 * A note on where these belong. ISO 9001 and ISO 14001 certify quality and
 * environmental MANAGEMENT SYSTEMS. Neither is an information-security
 * certification — that would be ISO 27001, which MindSyncX does not hold. They
 * are worth showing, and they are exactly the kind of thing an enterprise
 * procurement checklist asks for, but they must not be presented in a way that
 * implies a security audit. The `note` field exists to keep that distinction on
 * the page rather than in a comment nobody reads.
 *
 * These expire on 2029-03-03 and depend on annual surveillance audits. When one
 * lapses, remove it here — a stale certification claim is worse than no claim.
 */

export interface Certification {
    /** The standard, as it should be written. */
    standard: string;
    /** What the standard actually covers, in plain words. */
    covers: string;
    certificateNumber: string;
    issuedBy: string;
    /** ISO date, so it sorts and formats predictably. */
    validUntil: string;
    /** Where a buyer can confirm it independently. */
    verifyUrl: string;
    /** Path to the certificate itself, served from public/. */
    documentUrl: string;
}

export const CERTIFICATIONS: Certification[] = [
    {
        standard: "ISO 9001:2015",
        covers: "Quality management",
        certificateNumber: "E20260347754",
        issuedBy: "Royal Assessments Pvt. Ltd., accredited by EGAC (IAF MLA)",
        validUntil: "2029-03-03",
        verifyUrl: "https://www.iafcertsearch.org",
        documentUrl: "/assets/docs/mindsyncx-labs-iso-9001.pdf",
    },
    {
        standard: "ISO 14001:2015",
        covers: "Environmental management",
        certificateNumber: "E20260347753",
        issuedBy: "Royal Assessments Pvt. Ltd., accredited by EGAC (IAF MLA)",
        validUntil: "2029-03-03",
        verifyUrl: "https://www.iafcertsearch.org",
        documentUrl: "/assets/docs/mindsyncx-labs-iso-14001.pdf",
    },
];

/** Certified scope, quoted from both certificates. */
export const CERTIFIED_SCOPE =
    "Design and development of AI software solutions including AI chatbots, virtual assistants and predictive analytics systems, along with enterprise AI integration services.";

/**
 * Shown wherever the certifications are, so nobody reads ISO 9001 as a security
 * assurance. Being explicit about what a certificate does not cover is what
 * makes the ones you do hold worth trusting.
 */
export const CERTIFICATION_NOTE =
    "These certify our quality and environmental management systems. They are not information-security certifications.";
